var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAiIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.332,
    height: 24.384,
    viewBox: "0 0 24.332 24.384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#85b3cd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-209.346 -185.083)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M220.609,189.049V186.3a1.221,1.221,0,1,0-2.442,0v2.745Z",
    transform: "translate(1.95 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M214.973,189.049h2.136V186.3a1.221,1.221,0,1,0-2.442,0v2.775C214.77,189.07,214.868,189.049,214.973,189.049Z",
    transform: "translate(1.176 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M210.567,193.33H212.9v-2.309c0-.046.011-.088.013-.133h-2.342a1.221,1.221,0,1,0,0,2.442Z",
    transform: "translate(0 1.283)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M226.368,191.021v2.309H228.7a1.221,1.221,0,0,0,0-2.442h-2.342C226.357,190.933,226.368,190.975,226.368,191.021Z",
    transform: "translate(3.76 1.283)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M224.109,189.049V186.3a1.221,1.221,0,1,0-2.442,0v2.745Z",
    transform: "translate(2.724 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M210.567,196.83H212.9v-2.442h-2.329a1.221,1.221,0,1,0,0,2.442Z",
    transform: "translate(0 2.057)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M228.7,197.888h-2.329v2.31c0,.045-.011.087-.013.132H228.7a1.221,1.221,0,0,0,0-2.442Z",
    transform: "translate(3.76 2.83)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M221.667,202.445v1.963a1.221,1.221,0,0,0,2.442,0v-1.963Z",
    transform: "translate(2.724 3.838)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M212.9,200.2v-2.31h-2.329a1.221,1.221,0,1,0,0,2.442h2.342C212.907,200.285,212.9,200.243,212.9,200.2Z",
    transform: "translate(0 2.83)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M228.695,194.388h-2.329v2.442h2.329a1.221,1.221,0,0,0,0-2.442Z",
    transform: "translate(3.762 2.057)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M214.973,202.451c-.105,0-.2-.022-.306-.032v2a1.221,1.221,0,0,0,2.442,0v-1.963Z",
    transform: "translate(1.176 3.832)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M218.167,202.445v1.963a1.221,1.221,0,0,0,2.442,0v-1.963Z",
    transform: "translate(1.95 3.838)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(214.117 190.27)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M218.411,194.33c-.1-.4-.166-.694-.2-.868-.028.162-.085.43-.17.8s-.271,1.105-.56,2.2h1.484l-.3-1.144C218.6,195.063,218.511,194.734,218.411,194.33Z",
    transform: "translate(-212.318 -188.418)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M226.01,189.331H215.286a2.036,2.036,0,0,0-2.033,2.034V202.09a2.035,2.035,0,0,0,2.033,2.033H226.01a2.035,2.035,0,0,0,2.033-2.033V191.365A2.036,2.036,0,0,0,226.01,189.331Zm-5.374,10.9-.343-1.307h-2.266l-.353,1.307H215.6l2.275-7h2.514l2.3,7Zm4.707,0H223.45v-6.973h1.894Z",
    transform: "translate(-213.253 -189.331)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/ai-icon.47c17b32.svg";
export { ForwardRef as ReactComponent };